import React from "react";
import "bootstrap/js/dist/tab";

export const bs5TabFormatFriendly = (string) => {
  let new_string = "bs-" + string.split(" ").join("-");
  new_string = new_string.split("'").join("-");

  return new_string;
};

export const Bootstrap5TabItemsContainer = ({ children }) => {
  return (
    <ul className="nav nav-tabs" id="myTab" role="tablist">
      {children}
    </ul>
  );
};

export const Bootstrap5TabItem = ({ children, id, idx }) => {
  return (
    <li className="nav-item" role="presentation">
      <button
        className={idx === 0 ? "nav-link active" : "nav-link"}
        id={`${bs5TabFormatFriendly(id)}-tab`}
        data-testid={`${bs5TabFormatFriendly(id)}-tab`}
        data-bs-toggle="tab"
        data-bs-target={`#${bs5TabFormatFriendly(id)}`}
        type="button"
        role="tab"
        aria-controls={bs5TabFormatFriendly(id)}
        aria-selected={idx === 0 ? "true" : "false"}
        style={{ color: "black" }}
      >
        {children}
      </button>
    </li>
  );
};

export const Bootstrap5TabPanelsContainer = ({ children }) => {
  return (
    <div className="tab-content" id="myTabContent">
      {children}
    </div>
  );
};

export const Bootstrap5TabPanel = ({ children, id, idx }) => {
  return (
    <div
      className={idx === 0 ? "tab-pane fade show active" : "tab-pane fade"}
      id={bs5TabFormatFriendly(id)}
      data-testid={`${bs5TabFormatFriendly(id)}-tabpanel`}
      role="tabpanel"
      aria-labelledby={`${bs5TabFormatFriendly(id)}-tab`}
    >
      {children}
    </div>
  );
};
